'use strict';
import isFunction from 'lodash/isFunction';
import React, {Component} from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {stopPropagation} from '../../../core-utilities/react-utils';
import {PeopleSelectorList} from '../PeopleSelectorList';

export const modalOptions = {
  isLegacy: true,
  modalProps: {
    modalClass: 'PeopleSelectorModal',
    useScrollWrapper: false,
    animation: 'slide-in-right',
  },
};

export class PeopleSelectorModalComponent extends Component {
  static propTypes = {
    onSuccess: T.func/* .isRequired*/,
    onCancel: T.func/* .isRequired*/,

    parentId: T.string,
    filterOptions: T.object,
  };

  static defaultProps = {
    // TODO: use to set default configuration for the empty option, currently selected, etc
  };

  constructor(props) {
    super(props);

    this.handleClickItem = this.handleClickItem.bind(this);
    this.handleClickNullItem = this.handleClickNullItem.bind(this);
  }

  handleClickItem(e, model) {
    if (isFunction(this.props.onSuccess)) {
      this.props.onSuccess(model);
    }
  }

  handleClickNullItem(e, model) {
    if (isFunction(this.props.onCancel)) {
      this.props.onCancel(model);
    }
  }

  render() {
    // TODO: we may need to transform the click actions into proper payload objects
    return (
      <PeopleSelectorList
        className={classNames("right-slide-modal", this.props.className)}
        parentId={this.props.parentId}
        nullable={this.props.nullable}
        nullLabel={this.props.nullLabel}
        filter={this.props.filter}
        filterOptions={this.props.filterOptions}
        useSelection={true}
        useSimple={this.props.useSimple}
        selected={this.props.selected}
        onClickNullItem={this.handleClickNullItem}
        onClickItem={this.handleClickItem}
        onClick={stopPropagation}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/personnel/components/PeopleSelectorModal/PeopleSelectorModalComponent.js